/**
 * Zoom locking.
 *
 * `user-scalable=no` in the viewport meta is honoured by an installed
 * home-screen app but deliberately ignored by iOS Safari, which is why
 * pinching still worked in the browser. Safari does, however, fire its own
 * non-standard gesture events for a pinch, and those can be cancelled.
 *
 * Double-tap zoom is already handled by `touch-action: manipulation` on the
 * body, so this only has to deal with pinch and with the accidental
 * two-finger zoom that happens while marking items quickly.
 */
export function lockZoom() {
  // Safari's pinch gestures. Not standard, absent elsewhere - hence the casts.
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(
      type,
      (e) => e.preventDefault(),
      { passive: false } as AddEventListenerOptions,
    );
  }

  // A second finger landing mid-gesture is the other way a zoom starts.
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1 && e.cancelable) e.preventDefault();
    },
    { passive: false },
  );

  // Safari also zooms on a double-tap that touch-action cannot always catch,
  // for instance across two different elements.
  let lastTap = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      const now = Date.now();
      if (now - lastTap < 300 && e.cancelable) e.preventDefault();
      lastTap = now;
    },
    { passive: false },
  );
}
